<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/statistiques" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour aux statistiques</a>
      <span class="crumb-current">Mes transferts</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Historique</p>
        <h1>Transferts effectués</h1>
        <p class="lead">Détail des transferts entrants et sortants.</p>
      </div>
    </div>
  </div>

  <div class="card-glass p-3 mb-3">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h4 class="mb-0">Historique</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="mb-0" for="monthSelectTransPerso">Mois</label>
        <select id="monthSelectTransPerso"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <p class="text-muted small mb-0">Par défaut seuls les transferts du mois courant s’affichent. Sélectionnez un mois
      passé pour consulter l’historique déjà chargé.</p>
  </div>

  <div class="row g-3">
    <div class="col-sm-6 col-lg-4" *ngFor="let t of transfertlist">
      <div class="card card-glass h-100">
        <div class="card-header border-0 text-white font-weight-bolder text-center">
          {{t.date | date:"dd/MM/yyyy H:mm:ss"}}
        </div>
        <div class="card-body">
          <div *ngIf="t.type==1; else inbound">
            <div class="metric-row"><span>Destinataire</span><strong>{{t.destinataire}}</strong></div>
            <div class="metric-row"><span>Montant</span><strong>{{t.amount | currency:t.sigleMonnaie}}</strong></div>
            <div class="metric-row"><span>Usage prévu</span><strong>{{t.motif}}</strong></div>
            <div class="metric-row"><span>Type</span><strong class="text-danger"><i
                  class="bi bi-arrow-up"></i></strong></div>
          </div>
          <ng-template #inbound>
            <div class="metric-row"><span>Émetteur</span><strong>{{t.emeteur}}</strong></div>
            <div class="metric-row"><span>Montant</span><strong>{{t.amount | currency:t.sigleMonnaie}}</strong></div>
            <div class="metric-row"><span>Usage prévu</span><strong>{{t.motif}}</strong></div>
            <div class="metric-row"><span>Type</span><strong class="text-success"><i
                  class="bi bi-arrow-down"></i></strong></div>
          </ng-template>
        </div>
        <div class="card-footer bg-transparent border-0 text-end">
          <button type="button" class="btn btn-outline-danger btn-sm"><i class="bi bi-trash mr-2"></i></button>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="!transfertlist || transfertlist.length === 0">
      <div class="card card-glass p-3 text-center text-muted">Aucun transfert enregistré.</div>
    </div>
  </div>
</div>
